import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import App from 'src/App';
import Register from 'src/pages/Register';
import LeadsScreen from 'src/pages/LeadsScreen';
import UserListScreen from 'src/pages/UserListScreen';
import AccountConfirmationScreen from 'src/pages/AccountConfirmationScreen';
import RoleListScreen from 'src/pages/admin/RoleListScreen';
import ForgotPasswordScreen from './pages/ForgotPasswordScreen';
import ActivateAccountScreen from './pages/auth/ActivateAccountScreen';
import LoginScreen from 'src/pages/auth/LoginScreen';
import ResetPasswordScreen from 'src/pages/auth/ResetPasswordScreen';
import AccountSettings from 'src/pages/auth/AccountSettings';
import SprintListScreen from './pages/sprints/SprintListScreen';
import CustomerListScreen from './pages/customers/CustomerListScreen';
import AccountListScreen from './pages/accounts/AccountListScreen';
import EcommerceTotalSalesRadial from './features/TestComponent';
import LeadEditorPage from './features/data-management/leads/LeadEditorPage';
import { LicenseInfo } from '@mui/x-license-pro';
import PlaybookList from './features/playbooks/PlaybookList';
import Dashboard from './features/Dashboard/Dashboard';
import ActivityTypeList from './features/outcomes/ActivityTypeList';
import GlobalUpdate from './features/global-update/GlobalUpdate';
import OrganisationScreen from './pages/OrganisationScreen';
import ChatPlayground from './features/AI/chat/pages/ChatPlayground';
import ChatBotScreen from './features/chatbot/components/chat-client/ChatBotScreen';
import ChatBotAdminScreen from './features/chatbot/components/chat-admin/ChatBotAdminScreen';
import EditChatScreen from './features/chatbot/components/chat-admin/EditChatScreen';
import OAuthStatus from './v2/features/Profile/EmailSettings/OAuthStatus';
import ReportPage from './v2/features/Reporting/ReportPage/ReportPage';

LicenseInfo.setLicenseKey(
    '8cee4c742e9aeb56d8f7cc334581059fTz04MTQ4MCxFPTE3MzU5MTczNzUwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
);

/*import {LeadFilterScreen } from 'src/features/sprints/LeadFilterScreen'*/
const container = document.getElementById('app');
const root = createRoot(container!);

root.render(
    <Router>
        <Routes>
            {/*<Route path="/" element={<Navigate to='/chatbot/admin' />} />*/}

            {/*<Route path="/" element={<Navigate to='/global-update' />} />*/}
            {/* <Route path="/editorexamples" element={<App Component={ExampleContentEditor} />} />*/}
            <Route path="/" element={<App Component={Dashboard} />} />

            <Route path="/activity-types" element={<App Component={ActivityTypeList} />} />
            <Route path="/global-update" element={<App Component={GlobalUpdate} />} />
            <Route path="/playbooks" element={<App Component={PlaybookList} />} />
            <Route path="/register" element={<App Component={Register} />} />
            <Route path="/login" element={<App Component={LoginScreen} />} />
            <Route path="/chatbot" element={<App Component={ChatBotScreen} />} />
            <Route path="/chatbot/admin" element={<App Component={ChatBotAdminScreen} />} />
            <Route path="/chatbot/admin/chat/:chatId" element={<App Component={EditChatScreen} />} />
            <Route path="/leads" element={<App Component={LeadsScreen} />} />
            <Route path="/leads/import" element={<App Component={LeadEditorPage} />} />
            <Route path="/activate-account" element={<App Component={ActivateAccountScreen} />} />
            <Route path="/account-settings/:userId" element={<App Component={AccountSettings} />} />
            <Route path="/forgot-password" element={<App Component={ForgotPasswordScreen} />} />
            <Route path="/email/oauth/complete" element={<App Component={OAuthStatus} />} />
            <Route path="/auth/password-reset/:token" element={<App Component={ResetPasswordScreen} />} />
            <Route path="/admin/user/list" element={<App Component={UserListScreen} />} />
            <Route path="/admin/roles/list" element={<App Component={RoleListScreen} />} />
            <Route path="/account/confirmation/:token" element={<App Component={AccountConfirmationScreen} />} />
            <Route path="/sprints" element={<App Component={SprintListScreen} />} />
            <Route path="/customers" element={<App Component={CustomerListScreen} />} />
            <Route path="/accounts" element={<App Component={AccountListScreen} />} />
            <Route path="/test" element={<App Component={EcommerceTotalSalesRadial} />} />
            <Route path="/admin/organizations" element={<App Component={OrganisationScreen} />} />
            <Route path="/admin/chat/playground" element={<App Component={ChatPlayground} />} />
            <Route path="/reports" element={<App Component={ReportPage} />} />

            <Route path="/apps/user/view/:userId" element={<App Component={AccountSettings} />} />
            {/*<Route path="/filters" element={<App Component={LeadFilterScreen} />} />*/}
        </Routes>
    </Router>,
);
